import React, { Component } from 'react';
import { connect} from "remx";

import authStore from "../../stores/auth";
import dataStore from "../../stores/data";

class SectionDataView extends Component {
    constructor(props) {
        super(props);
    
        this.state = {

        }

    }
    
    componentDidUpdate(prevProps, prevState) {
       
    }

    generateContent(){
        // console.log("generate")
        var content = this.props.data_per;
        let return_content = [];
        for (var key in content){
            if(!key.includes('id') && !key.includes('created_at') && !key.includes('updated_at'))
                return_content.push(<React.Fragment key={key}>
                                        <label className="nav-label mg-b-1-f" key={key}>{key.replace("_", " ")}</label>
                                        <p className="tx-13 mg-b-10">{content[key]}</p>
                                    </React.Fragment>);

        }
        return return_content;
    }

    render(){
        // console.log(this.props.data_per)
        return(
            <div className="section-nav">
                <label className="nav-label">Detail Data</label>
                <hr></hr>
                {this.generateContent()}
            </div>
        );
    }

}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
        data_per : dataStore.getters.getDataPer(),
    }
}

export default connect(mapStateToProps)(SectionDataView);